import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="32" viewBox="0 0 36 32">
    <path fill="#c0f2d6" d="M11.3 24h19.4l4.5-13.5H8.1" />
    <path
      d="M31.5 24.2L36 10.7c.1-.2 0-.5-.1-.7-.1-.2-.4-.3-.6-.3H8.7l-2-8.4c0-.3-.4-.5-.7-.5H.7c-.4 0-.7.3-.7.7s.3.8.8.8h4.7l5.7 24.2c-1.3.3-2.2 1.4-2.2 2.7 0 1.7 1.3 3 3 3s3-1.3 3-3c0-.5-.2-1.1-.4-1.5h11.3c-.3.4-.4 1-.4 1.5 0 1.7 1.3 3 3 3s3-1.3 3-3-1.3-3-3-3H12.6l-.4-1.5h18.5c.4.1.7-.2.8-.5zm-3 3.6c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5-1.5-.7-1.5-1.6.7-1.4 1.5-1.4zm-15 1.4c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5.7-1.5 1.5-1.5 1.5.7 1.5 1.5zm-1.6-6l-2.8-12h25.1l-4 12H11.9z"
      fill="#0eb87f"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/javascripts/svg/subscription.es6.js